import { render, staticRenderFns } from "./DisplayModeToggle.vue?vue&type=template&id=0d7e036c&scoped=true&"
import script from "./DisplayModeToggle.vue?vue&type=script&lang=js&"
export * from "./DisplayModeToggle.vue?vue&type=script&lang=js&"
import style0 from "./DisplayModeToggle.vue?vue&type=style&index=0&id=0d7e036c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7e036c",
  null
  
)

export default component.exports